import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DefaultExcelExport from '../../subcomponents/DefaultExcelExport';

export default function ExportExcelProgress({ disabled, jsonData, fileName, showRequiredProgram, showTjl }) {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const [excelDataRows, setExcelDataRows] = useState([]);
    const [excelHeaderRow, setExcelHeaderRow] = useState([]);

    useEffect(() => {
        if (jsonData) {
            let data = jsonData?.map(({ studentId, ...rest }) => rest);

            // Header row
            setExcelHeaderRow([
                `${resourceFinal[appLanguage].words.STUDENT}${resourceFinal[appLanguage].words.NUMBER.toLowerCase()}`,
                resourceFinal[appLanguage].words.NAME_FIRST,
                resourceFinal[appLanguage].words.NAME_INSERTION,
                resourceFinal[appLanguage].words.NAME_LAST,
                resourceFinal[appLanguage].words.CLASS,
                `${resourceFinal[appLanguage].words.POINTS} ${resourceFinal[appLanguage].words.POINTS_ACHIEVED.toLowerCase()}`,
                showRequiredProgram ? resourceFinal[appLanguage].words.REQUIRED_PROGRAM : null,
                showTjl ? resourceFinal[appLanguage].words.FLAGS_TJL : null,
            ]);

            // Data rows
            data = data.map(item => {
                if (item.hasOwnProperty('requiredProgramStatus')) {
                    switch (item.requiredProgramStatus) {
                        case "green":
                            item.requiredProgramStatus = "Afgerond";
                            break;
                        case "yellow":
                            item.requiredProgramStatus = "Bezig";
                            break;
                        case "red":
                            item.requiredProgramStatus = "Niet begonnen";
                            break;
                        case "":
                        case null:
                            item.requiredProgramStatus = "Niet van toepassing";
                            break;
                        default:
                            break;
                    }
                }

                if (item.hasOwnProperty('lifestyleStatus')) {
                    switch (item.lifestyleStatus) {
                        case 2:
                            item.lifestyleStatus = "Afgerond";
                            break;
                        case 1:
                            item.lifestyleStatus = "Bezig";
                            break;
                        case 0:
                        case "":
                        case null:
                            item.lifestyleStatus = "Niet begonnen";
                            break;
                        default:
                            break;
                    }
                }

                return item;
            });

            let dataRows = [];

            data?.forEach(item => {
                dataRows.push(
                    Object.keys(item).map(key => {
                        const value = item[key];

                        if (!showRequiredProgram && key.toLowerCase().includes("requiredprogramstatus")) {
                            return;
                        }

                        if (!showTjl && key.toLowerCase().includes("lifestylestatus")) {
                            return;
                        }

                        return value === null ? "" : value;
                    })
                );
            });

            setExcelDataRows(dataRows);
        }
    }, [jsonData]);

    return (
        <DefaultExcelExport
            headerRow={excelHeaderRow}
            dataRows={excelDataRows}
            fileName={fileName}
            buttonText={`${resourceFinal[appLanguage].words.EXPORT} ${resourceFinal[appLanguage].words.EXCEL.toLowerCase()}`}
            disabledCondition={disabled}
        />
    );
}
